import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

export class VirtualAgentStore extends Store {
  @observable public isVirtualAgentClient = false;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

VirtualAgentStore.DEFAULTS = {
  isVirtualAgentClient: false
};
